export { default as useFinProductCategories } from './useFinProductCategories';
